export enum FeatureToggle {
  TEST = 'TEST',
  WARRANTY_MILEAGE_DATES_VALIDATIONS = 'WARRANTY_MILEAGE_DATES_VALIDATIONS',
  OVERRULE_ON_EXTENDED_WARRANTY = 'OVERRULE_ON_EXTENDED_WARRANTY',
  NWS_ERROR_VALIDATION = 'NWS_ERROR_VALIDATION',
  FIRST_REGISTRATION_DATE_FROM_SOURCE = 'FIRST_REGISTRATION_DATE_FROM_SOURCE',
  LICENSE_PLATE_TO_VIN = 'LICENSE_PLATE_TO_VIN',
  DEALER_LINK_TO_PRODUCT = 'DEALER_LINK_TO_PRODUCT',
  MINIMUM_NUMBER_OF_DAYS_NL = 'MINIMUM_NUMBER_OF_DAYS_NL',
  MODEL_GROUP = 'MODEL_GROUP',
  AGE_AND_MILEAGE = 'AGE_AND_MILEAGE',
  MODELS = 'MODELS',
  PRICING_GROUP = 'PRICING_GROUP',
  UVMS_PROMOTIONS = 'UVMS_PROMOTIONS'
}
